import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelinePropertiesPage } from '@Integrations/Pipelines/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminConfigurePipelinePropertiesPage',
  setup(__props) {

    document.title = "Configure properties"

    const tid = useOrganizationUnitId()
    const id = useId()

    const datasetId = ref()
    const connectorId = ref()

    const {
        useCurrentUserQuery,
        usePipelineDetailsQuery,
        useDatasetPropertyNamesQuery,
        useConnectorPropertyNamesQuery,
        usePipelinePropertyNamesQuery,
        useExcludePipelineDatasetPropertyCommand,
        useIncludePipelineDatasetPropertyCommand,
        useExcludePipelineConnectorPropertyCommand,
        useIncludePipelineConnectorPropertyCommand,
        useExcludePipelinePropertyCommand,
        useIncludePipelinePropertyCommand
    } = useAdminConfigurePipelinePropertiesPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const datasetProperties = computed<string>(() => modelPipelineDetailsQueryV1.value?.DatasetProperties)
    const connectorProperties = computed<string>(() => modelPipelineDetailsQueryV1.value?.ConnectorProperties)
    const pipelineProperties = computed<string>(() => modelPipelineDetailsQueryV1.value?.PipelineProperties)

    const { runDatasetPropertyNamesQueryV1, modelDatasetPropertyNamesQueryV1 } = useDatasetPropertyNamesQuery(datasetId)
    const datasetPropertyNames = computed<string>(() => modelDatasetPropertyNamesQueryV1.value?.PropertyNames || [])

    const { dataStream, runConnectorPropertyNamesQueryV1, modelConnectorPropertyNamesQueryV1 } = useConnectorPropertyNamesQuery(connectorId)
    const connectorPropertyNames = computed<string>(() => modelConnectorPropertyNamesQueryV1.value?.PropertyNames || [])

    const { runPipelinePropertyNamesQueryV1, modelPipelinePropertyNamesQueryV1 } = usePipelinePropertyNamesQuery(id)
    const pipelinePropertyNames = computed<string>(() => modelPipelinePropertyNamesQueryV1.value?.PropertyNames || [])

    const { invokeIncludePipelineDatasetPropertyCommandV1, succeedIncludePipelineDatasetPropertyCommandV1 } = useIncludePipelineDatasetPropertyCommand(id, tid, userId)
    const { invokeExcludePipelineDatasetPropertyCommandV1, succeedExcludePipelineDatasetPropertyCommandV1 } = useExcludePipelineDatasetPropertyCommand(id, tid, userId)

    const { invokeIncludePipelineConnectorPropertyCommandV1, succeedIncludePipelineConnectorPropertyCommandV1 } = useIncludePipelineConnectorPropertyCommand(id, tid, userId)
    const { invokeExcludePipelineConnectorPropertyCommandV1, succeedExcludePipelineConnectorPropertyCommandV1 } = useExcludePipelineConnectorPropertyCommand(id, tid, userId)

    const { invokeIncludePipelinePropertyCommandV1, succeedIncludePipelinePropertyCommandV1 } = useIncludePipelinePropertyCommand(id, tid, userId)
    const { invokeExcludePipelinePropertyCommandV1, succeedExcludePipelinePropertyCommandV1 } = useExcludePipelinePropertyCommand(id, tid, userId)

    const availableDatasetPropertyNames = computed(() => datasetPropertyNames.value.filter(p => !datasetProperties.value.includes(p)))
    const availableConnectorPropertyNames = computed(() => connectorPropertyNames.value.filter(p => !connectorProperties.value.includes(p)))
    const availablePipelinePropertyNames = computed(() => pipelinePropertyNames.value.filter(p => !pipelineProperties.value.includes(p)))

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDetailsQueryV1()
        runPipelinePropertyNamesQueryV1()
    })

    watch(connectorId, () => {
        runConnectorPropertyNamesQueryV1()
    })

    watch(datasetId, () => {
        runDatasetPropertyNamesQueryV1()
    })

    watch(modelPipelineDetailsQueryV1, () => {
        datasetId.value = modelPipelineDetailsQueryV1.value.DatasetId
        connectorId.value = modelPipelineDetailsQueryV1.value.ConnectorId
        dataStream.value = modelPipelineDetailsQueryV1.value.DataStream
    })

    watch([
        succeedIncludePipelineDatasetPropertyCommandV1,
        succeedExcludePipelineDatasetPropertyCommandV1,
        succeedIncludePipelineConnectorPropertyCommandV1,
        succeedExcludePipelineConnectorPropertyCommandV1,
        succeedIncludePipelinePropertyCommandV1,
        succeedExcludePipelinePropertyCommandV1
    ], () => runPipelineDetailsQueryV1())

    function handleIncludePipelineDatasetPropertyCommandV1(propertyName: string) {
        invokeIncludePipelineDatasetPropertyCommandV1({ PropertyName: propertyName })
    }

    function handleExcludePipelineDatasetPropertyCommandV1(propertyName: string) {
        invokeExcludePipelineDatasetPropertyCommandV1({ PropertyName: propertyName })
    }

    function handleIncludePipelineConnectorPropertyCommandV1(propertyName: string) {
        invokeIncludePipelineConnectorPropertyCommandV1({ PropertyName: propertyName })
    }

    function handleExcludePipelineConnectorPropertyCommandV1(propertyName: string) {
        invokeExcludePipelineConnectorPropertyCommandV1({ PropertyName: propertyName })
    }

    function handleIncludePipelinePropertyCommandV1(propertyName: string) {
        invokeIncludePipelinePropertyCommandV1({ PropertyName: propertyName })
    }

    function handleExcludePipelinePropertyCommandV1(propertyName: string) {
        invokeExcludePipelinePropertyCommandV1({ PropertyName: propertyName })
    }

return { __sfc: true,tid, id, datasetId, connectorId, useCurrentUserQuery, usePipelineDetailsQuery, useDatasetPropertyNamesQuery, useConnectorPropertyNamesQuery, usePipelinePropertyNamesQuery, useExcludePipelineDatasetPropertyCommand, useIncludePipelineDatasetPropertyCommand, useExcludePipelineConnectorPropertyCommand, useIncludePipelineConnectorPropertyCommand, useExcludePipelinePropertyCommand, useIncludePipelinePropertyCommand, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1, datasetProperties, connectorProperties, pipelineProperties, runDatasetPropertyNamesQueryV1, modelDatasetPropertyNamesQueryV1, datasetPropertyNames, dataStream, runConnectorPropertyNamesQueryV1, modelConnectorPropertyNamesQueryV1, connectorPropertyNames, runPipelinePropertyNamesQueryV1, modelPipelinePropertyNamesQueryV1, pipelinePropertyNames, invokeIncludePipelineDatasetPropertyCommandV1, succeedIncludePipelineDatasetPropertyCommandV1, invokeExcludePipelineDatasetPropertyCommandV1, succeedExcludePipelineDatasetPropertyCommandV1, invokeIncludePipelineConnectorPropertyCommandV1, succeedIncludePipelineConnectorPropertyCommandV1, invokeExcludePipelineConnectorPropertyCommandV1, succeedExcludePipelineConnectorPropertyCommandV1, invokeIncludePipelinePropertyCommandV1, succeedIncludePipelinePropertyCommandV1, invokeExcludePipelinePropertyCommandV1, succeedExcludePipelinePropertyCommandV1, availableDatasetPropertyNames, availableConnectorPropertyNames, availablePipelinePropertyNames, handleIncludePipelineDatasetPropertyCommandV1, handleExcludePipelineDatasetPropertyCommandV1, handleIncludePipelineConnectorPropertyCommandV1, handleExcludePipelineConnectorPropertyCommandV1, handleIncludePipelinePropertyCommandV1, handleExcludePipelinePropertyCommandV1 }
}

})